import { render, staticRenderFns } from "./VcCheckbox.vue?vue&type=template&id=52148e55&scoped=true"
import script from "./VcCheckbox.vue?vue&type=script&lang=js"
export * from "./VcCheckbox.vue?vue&type=script&lang=js"
import style0 from "./VcCheckbox.vue?vue&type=style&index=0&id=52148e55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52148e55",
  null
  
)

export default component.exports